/* Luxe-laag: spotlight + tilt op kaarten, magnetische knoppen, pootjes-spoor. Uit bij aanraak of verminderde beweging. */
(function () {
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (fine && !calm) {
    var CARD = '.need-picker__card, .promo-mosaic__tile, .abv__card, .shopc__card, .pgch__card';
    var raf = 0;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest(CARD);
      var mag = e.target.closest && e.target.closest('.hero__cta, [data-magnetic]');
      if (!card && !mag) return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        if (card) {
          var r = card.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.style.setProperty('--mx', (x * 100) + '%');
          card.style.setProperty('--my', (y * 100) + '%');
          card.style.setProperty('--ry', ((x - 0.5) * 6) + 'deg');
          card.style.setProperty('--rx', ((0.5 - y) * 6) + 'deg');
        }
        if (mag) {
          var b = mag.getBoundingClientRect();
          mag.classList.add('lp-magnet');
          mag.style.transform = 'translate(' + ((e.clientX - b.left - b.width / 2) * 0.18) + 'px,' + ((e.clientY - b.top - b.height / 2) * 0.28) + 'px)';
        }
      });
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest(CARD);
      if (card && !card.contains(e.relatedTarget)) { card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg'); }
      var mag = e.target.closest && e.target.closest('.hero__cta, [data-magnetic]');
      if (mag && !mag.contains(e.relatedTarget)) mag.style.transform = '';
    }, { passive: true });
  }

  if (!calm) {
    var PAW = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="6.5" cy="10" r="1.8"/><circle cx="10.5" cy="6.2" r="1.8"/><circle cx="15.5" cy="6.2" r="1.8"/><circle cx="19" cy="10" r="1.8"/><path d="M12.8 12c-3 0-5.3 2.7-5.3 4.8 0 1.5 1.2 2.4 2.7 2.4 1 0 1.5-.5 2.6-.5s1.6.5 2.6.5c1.5 0 2.7-.9 2.7-2.4 0-2.1-2.3-4.8-5.3-4.8z"/></svg>';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.product-form__submit, .hero__pet-submit, .sticky-atc__btn, .rec__add:not(.rec__add--link)');
      if (!t || !document.body.animate) return;
      for (var i = 0; i < 4; i++) {
        var p = document.createElement('span');
        p.className = 'lp-paw';
        p.innerHTML = PAW;
        p.style.left = e.clientX + 'px';
        p.style.top = e.clientY + 'px';
        document.body.appendChild(p);
        var dx = (i - 1.5) * 34, dy = -30 - i * 22;
        var a = p.animate([
          { transform: 'translate(0,0) scale(.4) rotate(0deg)', opacity: 0.95 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(1) rotate(' + (i % 2 ? 24 : -24) + 'deg)', opacity: 0 }
        ], { duration: 750, delay: i * 70, easing: 'cubic-bezier(0.2,0.8,0.2,1)', fill: 'backwards' });
        a.onfinish = (function (n) { return function () { n.remove(); }; })(p);
      }
    });
  }
})();
